import { HttpAxios } from "@/common/services/httpAxios";
import { IAccount, ISetUp, IUserSSO } from "./interfaceUserGateway";

class UserGateway {
  async getAccounts(): Promise<IAccount[]> {
    try {
      const response = await HttpAxios.userGateway.get<IAccount[]>(
        `/dxp-user-gateway/users/accounts`
      );
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async getSetUp(accountId: string): Promise<ISetUp> {
    try {
      const response = await HttpAxios.userGateway.get<ISetUp>(
        `/dxp-user-gateway/users/accounts/${accountId}/set-up`
      );
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async setUserSSO() {
    try {
      const response = await HttpAxios.userGateway.post<IUserSSO>(
        `/dxp-user-gateway/users/sso/integration`
      );
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default new UserGateway();
